import { Link } from "react-router-dom";
import {
  CONDUCT_SECTIONS,
  LEGAL_EFFECTIVE_DATE,
  PRIVACY_SECTIONS,
  TERMS_CLAUSES,
} from "../content/legalPages";

type Doc = "terms" | "code-of-conduct" | "privacy";

type Props = {
  doc: Doc;
};

export function LegalDocumentPage({ doc }: Props) {
  if (doc === "terms") {
    return (
      <article className="page page--wide legal-page">
        <p className="eyebrow">Legal</p>
        <h1>Terms of Service</h1>
        <p className="page-summary">
          Effective {LEGAL_EFFECTIVE_DATE}. Operator of{" "}
          <a href="https://tnkmain.tnktrade.ai">tnkmain.tnktrade.ai</a> — TNK Main / AI For
          POS. Related:{" "}
          <Link to="/code-of-conduct">Code of Conduct</Link> ·{" "}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        <div className="legal-columns-head" aria-hidden="true">
          <span>Official / legally binding</span>
          <span>Plain English</span>
        </div>
        <div className="legal-clauses">
          {TERMS_CLAUSES.map((c, i) => (
            <div key={i} className="legal-clause">
              <div className="legal-clause-official">
                <p>{c.official}</p>
              </div>
              <div className="legal-clause-plain">
                <p>{c.plain}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="legal-footnote">
          Corporate registered address is not published in this repository — replace this
          notice with counsel-approved entity details when available.
        </p>
      </article>
    );
  }

  if (doc === "code-of-conduct") {
    return (
      <article className="page legal-page">
        <p className="eyebrow">Legal</p>
        <h1>Code of Conduct</h1>
        <p className="page-summary">
          Effective {LEGAL_EFFECTIVE_DATE}. Related: <Link to="/terms">Terms of Service</Link> ·{" "}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
        {CONDUCT_SECTIONS.map((s) => (
          <section key={s.heading} className="legal-section">
            <h2>{s.heading}</h2>
            {s.heading === "Where these rules apply" || s.heading === "Unacceptable" ? (
              <ul className="marketing-bullets">
                {s.body.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            ) : (
              s.body.map((line) => <p key={line}>{line}</p>)
            )}
          </section>
        ))}
      </article>
    );
  }

  return (
    <article className="page legal-page">
      <p className="eyebrow">Legal</p>
      <h1>Privacy Policy</h1>
      <p className="page-summary">
        Effective {LEGAL_EFFECTIVE_DATE}. Related: <Link to="/terms">Terms of Service</Link> ·{" "}
        <Link to="/code-of-conduct">Code of Conduct</Link>.
      </p>
      {PRIVACY_SECTIONS.map((s) => (
        <section key={s.heading} className="legal-section">
          <h2>{s.heading}</h2>
          {s.body.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </section>
      ))}
      <p className="legal-footnote">Last updated: {LEGAL_EFFECTIVE_DATE}</p>
    </article>
  );
}
